import { rootApi } from '../rootApi';

export const matnrPartsPriceReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getMatnrPartsPriceReport: builder.query({
            query: (body = {}) => ({
                url: 'v1/matnrpartprice/getlist',
                method: 'POST',
            body: {
                pageSize: body?.pageSize ?? 20,
                pageNumber: body?.pageNumber ?? 1,
                filters: body?.filters ?? null,
                sorts: body?.sorts ?? null,
                appBranchId: body?.appBranchId ?? null,
                compressionType: 0
            }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                        filterOptions: response.data.filterOptions ?? null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['MatnrPartsPriceReport']
        }),

        exportMatnrPartsPriceToExcel: builder.query({
            query: (body = {}) => ({
                url: 'v1/matnrpartprice/exporttoexcel',
                method: 'POST',
                body: {
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    appBranchId: body?.appBranchId ?? null,
                    compressionType: 0

                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                return { fileBase64: null, error: true };
            }
        })
    }),
    overrideExisting: false
});

export const {
    useGetMatnrPartsPriceReportQuery,
    useLazyExportMatnrPartsPriceToExcelQuery
} = matnrPartsPriceReportApi;